<template>
  <div>
    <div class="row">
      <breadcrumb>
        <template v-slot:1>
          <router-link :to="{ name: 'informes' }">{{
            $t("informes")
          }}</router-link>
        </template>
        <template v-slot:2>
          <li class="breadcrumb-item active" aria-current="page">
            {{ $t("consultarInventarioPorSectores") }}
          </li>
        </template>
      </breadcrumb>
      <CabeceraInformes
        v-if="sectores"
        :idBusiness="idBusiness"
        :listBusinesses="listBusinesses"
        :listSectores="listaSectores"
        :idTpv="idTpv"
        :idSector="idSector"
        :listTpv="listTpv"
        :quitarFechas="true"
        :conBusquedaPorHoras="false"
        :conTodos="true"
        :sectores="true"
        id="cabecera"
      />
      <div class="col-md-4 text-left" style="margin-bottom: 4px">
        <el-select class="select-default mb-2 filterTag"
          size="large"
          filterable
          v-model="idFiltro"
          @change="consultarAlmacenPorSectores()"
          placeholder="Filtrar por etiqueta">
            <el-option v-for="tag in filterTag "
              class="select-primary"
              :value="tag.id"
              :label="tag.name"
              :key="tag.id">
            </el-option>
        </el-select>
      </div>
      <div class="col-md-8">
        <el-dropdown  class="float-right">
          <el-button type="primary" size="small">
                    <i class="fa fa-file"></i>
                    {{ $t("exportarInforme")
                    }}<i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
          <el-dropdown-menu slot="dropdown">
            <a :href="urlExportExcel">
              <el-dropdown-item class="text-success">
                <strong
                  ><i class="fa fa-file-excel"></i>
                  {{ $t("exportarExcel") }}</strong
                >
              </el-dropdown-item>
            </a>

          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="table-responsive">
        <div class="col-md-12" v-if="respuesta">
          <template>
            <table class="table table-bordered table-striped tableVentas text-nowrap">
              <thead class="thead-dark">
                <tr>
                  <th></th>
                  <th v-for="obj in data" colspan="7">{{obj.nameTpv}}</th>
                  <th>{{ $t("totalCargar") }}</th>
                </tr>
                <tr>
                  <th></th>
                  <template v-for="obj in data">
                    <th>{{ $t("optimo") }}</th>
                    <th>{{ $t("inicioReal") }}</th>
                    <th>{{ $t("entradas") }}</th>
                    <th>{{ $t("ventas") }}</th>
                    <th>{{ $t("salidas") }}</th>
                    <th>{{ $t("finalBarra") }}</th>
                    <th>{{ $t("cargar") }}</th>
                  </template>
                  <th>{{ $t("totalCargar") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <tr v-for="(prod, index) in data[0].products" :key="prod.id">
                    <th>{{ prod.nameSubproduct }}</th>
                    <template v-for="obj in data">
                      <template v-if="obj.products[index] != undefined">
                        <td>{{ obj.products[index].stockOptimo }}</td><!--Optimo-->
                        <td>{{ obj.products[index].unidadesUltimoInventario }}</td><!--Inicio Real-->
                        <td>{{ obj.products[index].precargas }}</td><!--Entradas-->
                        <td>{{ parseFloat(parseFloat(obj.products[index].unidadesUltimoInventario) - parseFloat(obj.products[index].unidadesActuales)).toFixed(3) }}</td><!--Ventas-->
                        <td>{{ obj.products[index].mermas }}</td><!--Salidas-->
                        <!--<td>{{ parseFloat(obj.products[index].unidadesActuales) + obj.products[index].precargas + obj.products[index].mermas }}</td>--><!--Final barra-->
                        <td>{{ parseFloat(obj.products[index].unidadesActuales + obj.products[index].precargas - obj.products[index].mermas) }}</td><!--Final barra-->
                        <!--<td 
                          :style="((parseFloat(obj.products[index].unidadesActuales) + obj.products[index].precargas + obj.products[index].mermas) - obj.products[index].stockOptimo) >= 0 ? 
                            'background-color: #C3E6CB' : 'background-color: #F5C6CB'">
                          {{ (parseFloat(obj.products[index].unidadesActuales) + obj.products[index].precargas + obj.products[index].mermas) - obj.products[index].stockOptimo }}
                        </td>-->
                        <td 
                          :style="((parseFloat(obj.products[index].unidadesActuales + obj.products[index].precargas - obj.products[index].mermas) - obj.products[index].stockOptimo)) >= 0 ? 
                            'background-color: #C3E6CB' : 'background-color: #F5C6CB'"> 
                          {{ parseFloat(parseFloat(obj.products[index].unidadesActuales + obj.products[index].precargas - obj.products[index].mermas) - obj.products[index].stockOptimo).toFixed(3) }}
                        </td>
                      </template>
                    </template>
                    <td :style="listProdCargar[index] >= 0 ? 'background-color: #C3E6CB' : 'background-color: #F5C6CB'">
                      {{ listProdCargar[index] }}
                    </td>
                  <tr>
                </tr>
              </tbody>
            </table>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  Button,
  ButtonGroup,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Option,
  Select,
  Loading,
} from "element-ui";
import swal from "sweetalert2";
import moment from "moment";
import { mapState, mapMutations } from 'vuex';
import CabeceraInformes from "../../../../components/CabeceraInformes/CabeceraInformes";
import bus from "../../../../bus";
import Breadcrumb from "../../../../components/Breadcrumb/Breadcrumb.vue";

export default {
  created() {
    this.loading = Loading.service({text: this.$t('cargando')});
    this.$store.dispatch("setNameRoute", this.$i18n.t("consultarInventarioPorSectores"));

    if (this.listaSectores.length > 1) {
        this.idSector = this.listaSectores[0].id;

        //Dentro, establecer un todos como primera opción y después llamar a getTpv()
        this.getBusinessesBySector();
    } else {
        //Cargar método local donde me traigo los sectores
        this.getSectores();
    }
  },

  components: {
    CabeceraInformes,
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Option.name]: Option,
    [ButtonGroup.name]: ButtonGroup,
    Breadcrumb,
  },
  data() {
    CabeceraInformes;
    return {
      loading: false,
      respuesta: true,

      listBusinesses: [],
      data: [""],
      listProdCargar: [],
      listTpv: [],
      idTpv: -1,
      idBusiness: 0,
      idsTPV: [],
      namesTPV: [],
      filterTag: [],
      idFiltro: 0,
      nombreFiltro: 'none'
    };
  },
  computed: {
    ...mapState(["listaSectores", "sectores"]),

    urlExportExcel() {
      var tpv = "";

      this.idsTPV.forEach(function(d) {
        tpv += d + ",";
      });

      let url = this.$store.getters.apiUrl +
        "/almacen/exportarInformeDeAlmacenPorSectores?idsTpv=" +
        tpv +
        "&filtro=" + 
        this.nombreFiltro +
        "&jwt=" +
        this.$store.getters.jwt;
        
      return (
        url
      );

    },
  },
  methods: {
    ...mapMutations(['changeListaSectores']),
    selectNombreFiltro() {

      if (this.idFiltro == 0) {
        this.nombreFiltro = "none";
      } else {
        this.nombreFiltro = this.filterTag.filter(filter => filter.id == this.idFiltro)[0].name;
      }
    },
    getCategory() {

      const sector = this.listaSectores.find(sector => sector.id == this.idSector);
      const idBusinessMaster = sector.idBusinessMaster;
      
      var config = {
          params: {
              idBusiness: idBusinessMaster,
              jwt: this.$store.getters.jwt
          },
          headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
      };

      let vm = this;
      this.axios.get(this.$store.getters.apiUrl + 'subproducts/getTagsByBusiness', config)
          .then(function (response) {
              if (response.data.response) {

                  vm.filterTag = [];

                  if (response.data.result.length === 0) {
                      let category = {
                          name: "Todas las etiquetas",
                          id: 0,
                          code: 0,
                          parentCode: 0
                      };
                      vm.filterTag.push(category);
                  }

                  for (let i = 0; i < response.data.result.length; i++) {

                      if (i === 0) {
                          let category = {
                              name: "Todas las etiquetas",
                              id: 0,
                              code: 0,
                              parentCode: 0
                          };
                          vm.filterTag.push(category);
                      }

                      let categoryname = {
                          name: response.data.result[i].name,
                          id: response.data.result[i].id,
                          code: response.data.result[i].code,
                          parentCode: response.data.result[i].parentCode
                      };

                      vm.filterTag.push(categoryname)

                  }

              } else {
                  vm.loading.close();
                  swal({
                      title: vm.$t('atencion'),
                      text: response.data.message,
                      confirmButtonClass: 'btn btn-info btn-fill',
                      type: 'error'
                  });
              }

          });
    },
    cambioSector(idSectorData, listBusinesses) {
      if (listBusinesses) {
        this.listBusinesses = listBusinesses;
      }

      this.idSector = idSectorData;
      this.idBusiness = -1; 

      this.getCategory();
      this.getAllTpvsServerFromBusinesses();
    },
    //CABECERAS
    cambioBusiness(idBusinessData, listTpv) {
      if (listTpv) {
        this.listTpv = listTpv;
      }
      this.loading = Loading.service({ text: "Cargando..." });
      this.idBusiness = idBusinessData;

      this.idTpv = -1;
      this.idsTPV = [];

      this.getCategory();

      if ((!this.sectores && !this.$cookies.isKey("sectores")) || idBusinessData != -1) {
        this.getTpv();
      } else {
        this.getAllTpvsServerFromBusinesses();
      }
    },
    emitirConsulta() {
      this.consultarAlmacenPorSectores();
    },
    cambioTpv(idTpvData, filtrar) {
      if (idTpvData != undefined) {
        this.idTpv = idTpvData;
        this.changeTPV();
      }

      this.idTpv = idTpvData;
      this.emitirConsulta();
    },
    getSectores() {
      let config = {
          params: {
              jwt: this.$store.getters.jwt,
          },
          headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
      };

      let vm = this;
      this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesSectors", config)
        .then(function (response) {
          if (response.data.response) {
            response.data.result["sectores"].forEach((sector) => {
            sector.idBusinessMaster = parseInt(sector.idBusinessMaster);
            sector.id = parseInt(sector.id);
          });
              
          vm.changeListaSectores(response.data.result["sectores"]);
          vm.idSector = vm.listaSectores[0].id;  
          vm.getBusinessesBySector();
        }
      }).catch(function (error) {
        console.log(error);
      })
    },
    getTpv() {
      if (this.idBusiness.length > 0 || (this.sectores && this.$cookies.isKey('sectores'))) {
        this.listTpv = [];
        this.idsTPV = [];
        var config = {
          params: {
            idBusiness: this.idBusiness,
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        let vm = this;
        this.axios
          .get(this.$store.getters.apiUrl + "general/getServerTpvsByBusiness", config)
          .then(function(response) {
            if (response.data.response) {
              vm.listTpv = [];
              vm.idsTPV = [];

              for (let i = 0; i < response.data.result.length; i++) {
                vm.idsTPV.push(response.data.result[i].id);
              }

              vm.listCheckBoxTpv = response.data.result;

              for (let i = 0; i < response.data.result.length; i++) {
                let printername = {
                  nameShow: response.data.result[i].nameShow,
                  id: response.data.result[i].id,
                };

                vm.listTpv.push(printername);
              }

              vm.consultarAlmacenPorSectores();
            }
            vm.loading.close();
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    },
    getBusinessesBySector() {
      let config = {
          params: {
              jwt: this.$store.getters.jwt,
          },
          headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
      };

      var params = {
          idBusiness: this.listaSectores[0].idBusinessMaster,
          idSector: this.idSector,
          jwt: this.$store.getters.jwt,
      };

      let vm = this;
      this.axios.post(this.$store.getters.apiUrl + "general/getBusinessesBySector", params, config)
        .then(function (response) {
          if (response.data.response) {
            //Recojo todos los negocios de la carga inicial del sector seleccionado
            vm.listBusinesses = response.data.result;
            vm.idBusiness = -1;

            //Recojo todos los tpv
            vm.getAllTpvsServerFromBusinesses();
          }
        }).catch(function (error) {
            console.log(error);
        })
    },
    getAllTpvsServerFromBusinesses() {
      let businesses = [];

      this.listBusinesses.forEach(business => {
        if (business.id != -1) {
          businesses.push(parseInt(business.id));
        }
      });

      let config = {
          params: {
              jwt: this.$store.getters.jwt,
              idBusiness: businesses,
          },
          headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
      };

      let vm = this;
      this.axios.get(this.$store.getters.apiUrl + "general/getTpvsServerByListBusiness", config)
          .then(function (response) {
            if (response.data.response) {
              vm.listTpv = [];
              vm.idsTPV = [];
              vm.namesTPV = [];

              for (let i = 0; i < response.data.result.length; i++) {
                vm.idsTPV.push(response.data.result[i].id);
                vm.namesTPV.push(response.data.result[i].nameShow);
              }

              for (let i = 0; i < response.data.result.length; i++) {
                let printername = {
                  nameShow: response.data.result[i].nameShow,
                  id: response.data.result[i].id,
                };

                vm.listTpv.push(printername);
              }

              vm.consultarAlmacenPorSectores();
            }
            vm.loading.close();
      }).catch(function (error) {
          console.log(error);
      })
    },
    changeTPV() {
      if (this.idTpv === -1) {
        this.idsTPV = [];

        for (let i = 0; i < this.listTpv.length; i++) {
          this.idsTPV.push(this.listTpv[i].id);
        }
      } else {
        this.idsTPV = [];
        this.idsTPV.push(this.idTpv);
      }
    },
    consultarAlmacenPorSectores() {
      this.selectNombreFiltro();

      this.loading = Loading.service({text: this.$t('cargando')});

      var config = {
        params: {
          idsTpv: this.idsTPV,
          filtro: this.nombreFiltro,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;

      this.axios
        .get(this.$store.getters.apiUrl + "almacen/consultarAlmacenPorSectores2", config)
        .then(function(response) {
          if (response.data.response) {
            vm.data = "";
            vm.data = response.data.result;

            vm.respuesta = true;
            vm.calcularMaximosACargar();
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });

            vm.respuesta = false;
          }
          vm.loading.close();
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    calcularMaximosACargar() {
      this.listProdCargar = [];
      let totalProductos = Object.keys(this.data[0].products).length;

      for(let i = 0; i<totalProductos; i++) {
        this.data.forEach(prod => {
          if(prod.products[i] != undefined) {
            if(this.listProdCargar[i] != undefined) {
              this.listProdCargar[i] += parseFloat(prod.products[i].unidadesActuales) - parseFloat(prod.products[i].stockOptimo);
            } else {
              this.listProdCargar.push(parseFloat(prod.products[i].unidadesActuales) - parseFloat(prod.products[i].stockOptimo));
            }
          }
        })
      }
    }
  },
};
</script>
<style scoped>
.active-filter {
  color: #1E22AA;
  border-color: #b9d0d7;
  background-color: #e8eff2;
}
.active-filter-mesas {
  background-color: #f38a09;
  border-color: #b9d0d7;
}
a li {
  color: #111;
}
.card {
  padding: 20px;
}
.div-export {
  margin-bottom: 10px;
}
.sunday {
  color: rgb(128, 0, 0);
}
.fridaySaturday {
  color: rgb(0, 128, 64);
}
.trDay:hover {
  background-color: rgba(68, 125, 247, 0.2) !important;
}
.justify-content-right {
  margin-left: 15px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Subproductos/consultarInventarioPorSectores.vue